<template>
    <!-- 新建供应商联系人信息 -->
   <a-modal
      :title="title"
      :visible="isVisible"
      :destroyOnClose="true"
      :maskClosable="false"
      width="52%"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div>
        <a-form-model
          ref="formRef"
          :model="form"
          labelAlign="right"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          :rules="formRules"
        >
          <a-row>
            <a-col :span="24">
              <a-form-model-item v-if="isCutomerName" label="对应供应商" :labelCol="rowLabel" :wrapperCol="rowWrapper">
                <b >{{ isCutomerName }}</b>
              </a-form-model-item>
              <a-form-model-item v-else label="对应供应商" prop="customerName" :labelCol="rowLabel" :wrapperCol="rowWrapper">
                <a-input v-model="form.customerName" placeholder="点击选择对应供应商" read-only class="choosePerson" @click="openModal('supplier')" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="姓名" prop="linkmanName">
                <a-input v-model="form.linkmanName" placeholder="请输入姓名"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="手机">
                <a-input v-model="form.linkmanTel"  placeholder="请输入手机号码" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="部门" prop="dept">
                <a-input v-model="form.linkmanDept" placeholder="请输入部门" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="职务" prop="linkmanDuty">
                <a-input v-model="form.linkmanDuty"  placeholder="请输入职务" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="分类" prop="linkmanType">
                <a-select @change="typeChange" v-model="form.linkmanType" placeholder="请选择分类" style="width: 100%;">
                  <a-select-option v-for="(item,index) in linkNameTypeList" :key="index" :value="item.label" >
                    {{item.value}}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="性别">
                <a-radio-group v-model="form.linkmanGender">
                  <a-radio :value="0">男</a-radio>
                  <a-radio :value="1">女</a-radio>
                  <a-radio :value="2">保密</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="上传附件" :labelCol="rowLabel" :wrapperCol="rowWrapper">
                <upload-attachment ref="uploadRef" :val-name="valName"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <public-dialog
        :title="publicDia.title"
        :dialog-visible="publicDia.visible"
        :component-name="publicDia.comName"
        @logSuccess="publicDialogSucc"
        @cancel="publicDialogCancel"
      />
      <personnel :visible="personVisible" :chooseData="personData" :isOnce="isOncePerson" @close="personClose" @success="personSuccess" />
      <template #footer>
        <a-button @click="handleCancel" style="background-color:#F2F2F2">取消</a-button>
        <a-button  type="primary" :loading="loading" @click="handleOk">保存</a-button>
      </template>
   </a-modal>
</template>

<script>
import personnel from '@/components/personnel'
import uploadAttachment from '@/views/common/Upload'
import { getNowFormatDate } from '@/utils/timer'
import publicDialog from '@/components/modelDialog/publicDialog.vue'
export default {
  name: 'AddEdit',
  components: { personnel, uploadAttachment, publicDialog },
  provide () {
    return {
      formData: this,
      type: true
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      publicDia: { visible: false },
      form: { },
      loading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      rowLabel: { span: 3 },
      rowWrapper: { span: 19 },
      formRules: {
        customerName: [
          { required: true, message: '请选择对应供应商', trigger: 'change' }
        ]
        /* linkmanName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ], */
        /* linkmanType: [
          { required: true, message: '请选择分类', trigger: 'blur' }
        ], */
        /* linkmanDuty: [
          { required: true, message: '请输入职务', trigger: 'blur' }
        ] */
      },
      // 选择人员
      personVisible: false,
      personData: {},
      isOncePerson: true,
      uploadFileList: [],
      valName: 'uploadFileList',
      linkNameTypeList: [],
      isCutomerName: '',
      isCustomerId: ''
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.handleCancel()
      }
    }
  },
  mounted () {
    this.linkNameTypeList = this.$store.state.account.dictData.linkNameTypeList
  },
  methods: {
    getNowFormatDate,
    setCustomer (val) {
      this.isCutomerName = val.companyName
      this.isCustomerId = val.id
      // this.$set(this.form, 'customerName', val.companyName)
    },
    typeChange (val) {
      this.form.linkmanType = val
    },
    openModal (type) { // 弹窗选择一行数据
      this.publicDia.visible = true
      this.publicDia.title = '点击选择对应供应商'
      this.publicDia.comName = 'purchase/supplier'
    },
    publicDialogSucc (data, typeVal) { // 数据选择成功-赋值
      this.$set(this.form, 'customerId', data.id)
      this.$set(this.form, 'customerName', data.companyName)
      this.publicDia.visible = false
    },
    publicDialogCancel () { // 取消选择数据
      this.publicDia.visible = false
    },
    setForm (formValue) {
      this.form = {...formValue}
      // 是否有附件
      if (this.form.fileIds) {
        // string 转 数组  循环获取附件信息
        let fileList = this.form.fileIds.split(',')
        this.$nextTick(() => {
          this.$refs.uploadRef.getFile(fileList)
        })
      }
    },
    handleOk () {
      this.$refs.formRef.validate((valid) => {
        // setCount字段代表是否对图片进行删除/上传操作，为0时附件未发生变化则无需赋值
        if (this.$refs.uploadRef.setCount !== 0) {
          this.form.fileIds = this.uploadFileList
        }
        if (valid) {
          this.loading = true
          this.form.customerType = 2 // 1客户联系人 2供应商联系人
          if (this.title === `[新建]-${this.$tree([], 'purchase/supplier/supplierLink/index')}`) {
            if (this.isCustomerId) {
              this.form.customerId = this.isCustomerId
            }
            this.$post('/linkman/add', this.form).then(res => {
              if (res.data.status === 1) {
                this.$message.success(res.data.message)
                this.$emit('success', this.form)
                this.resetForm()
              } else {
                this.$message.warning(res.data.message)
              }
            }).finally(r => {
              setTimeout(() => {
                this.loading = false
              }, 200)
            })
          } else {
            this.$post('/linkman/update', this.form).then(res => {
              if (res.data.status === 1) {
                this.$message.success(res.data.message)
                this.$emit('success')
                this.resetForm()
              } else {
                this.$message.warning(res.data.message)
              }
            }).finally(r => {
              setTimeout(() => {
                this.loading = false
              }, 200)
            })
          }
        }
      })
    },
    resetForm () {
      this.uploadFileList = []
      this.isCutomerName = ''
      this.isCutomerName = ''
      setTimeout(() => {
        this.form = {}
      }, 500)
    },
    handleCancel () {
      this.resetForm()
      this.$emit('close')
    },
    openPerson (name, id) {
      this.personVisible = true
      this.personData = { userId: id, userName: name }
    },
    personClose () {
      this.personVisible = false
    },
    personSuccess (data, type) {
      if (type === 'radioType') {
        this.form.upperCustomerName = data.username
        this.form.upperCustomerId = data.userId
      }
      this.personVisible = false
    }
  }
}
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/views/purchase/supplier/supplierLink/addEdit.vue